import BaseApi from "./baseApi";

class RetreatRoasterApi extends BaseApi {
  async getRetreatRoastData(data: Record<string, unknown> | object): Promise<any> {
    return this.API({
      url: "/retreatRoast/getRetreatRoastData",
      data: data,
      method: "post",
    });
  }

  async getSpritualRoastData(data: Record<string, unknown> | object): Promise<any> {
    return this.API({
      url: "/retreatRoast/getSpritualRoastData",
      data: data,
      method: "post",
    });
  }

  async getSpritualDirectorData(data: Record<string, unknown> | object): Promise<any> {
    return this.API({
      url: "/retreatRoast/get-spritual-director-data",
      data: data,
      method: "post",
    });
  }

  async getTeamRoastData(data: Record<string, unknown> | object): Promise<any> {
    return this.API({
      url: "/retreatRoast/getTeamRoastData",
      data: data,
      method: "post",
    });
  }

  async getLeadCoupleRoastData(data: Record<string, unknown> | object): Promise<any> {
    return this.API({
      url: "/retreatRoast/getLeadCoupleRoastData",
      data: data,
      method: "post",
    });
  }

  async gettalkRoastData(data: Record<string, unknown> | object): Promise<any> {
    return this.API({
      url: "/retreatRoast/gettalkRoastData",
      data: data,
      method: "post",
    });
  }

  async getServiceRoastData(data: Record<string, unknown> | object): Promise<any> {
    return this.API({
      url: "/retreatRoast/getServiceRoastData",
      data: data,
      method: "post",
    });
  }

  async getRetreatantRoastData(data: Record<string, unknown> | object): Promise<any> {
    return this.API({
      url: "/retreatRoast/getRetreatantRoastData",
      data: data,
      method: "post",
    });
  }

  async saveRetreatRoasterExcel(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/retreatRoast/saveRetreatRoasterExcel",
      data: data,
      method: "post",
    });
  }

  async deleteRetreatRoast(data: Record<string, unknown> | object): Promise<any> {
    return this.API({
      url: "/retreatRoast/deleteRetreatRoast",
      data: data,
      method: "put",
    });
  }

  async getRetreatLead(data: Record<string, unknown> | object): Promise<any> {
    return this.API({
      url: "/retreatRoast/getRetreatLead",
      data: data,
      method: "post",
    });
  }

  async updateRoaster(data: Record<string, unknown> | object): Promise<any> {
    return this.API({
      url: "/retreatRoast/updateRoaster",
      data: data,
      method: "post",
    });
  }

  async CreateRoaster(data: Record<string, unknown> | object): Promise<any> {
    return this.API({
      url: "/retreatRoast/CreateRoaster",
      data: data,
      method: "post",
    });
  }

  async getCouplesInRetreat(data: Record<string, unknown> | object): Promise<any> {
    return this.API({
      url: "/retreatRoast/getCouplesInRetreat",
      data: data,
      method: "post",
    });
  }

  async createLeads(data: Record<string, unknown> | object): Promise<any> {
    return this.API({
      url: "/retreatRoast/createLeads",
      data: data,
      method: "post",
    });
  }

  async removeCoupleFromRetreat(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: `/retreatRoast/removeCoupleFromRetreat`,
      method: "post",
      data: data,
    });
  }

  async updateRoasterTalk(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: `/retreatRoast/update-roaster-talk`,
      method: "post",
      data: data,
    });
  }

  async buildMyTeam(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: `/retreatRoast/build-my-team`,
      method: "post",
      data: data,
    });
  }
}
export default RetreatRoasterApi;
